import styles from "../../styles/ui/Callout.module.scss";

/**
 * Editorial pull-out for the one sentence in a section that must not be
 * skimmed past. Replaces the CSS-generated ::before chips, so the label is
 * real text that assistive tech can reach.
 */
const Callout = ({ label, icon: Icon, tone = "accent", children, className = "" }) => (
  <aside className={`${styles.callout} ${styles[tone]} ${className}`}>
    {label && (
      <p className={styles.label}>
        {Icon && <Icon aria-hidden="true" />}
        <span>{label}</span>
      </p>
    )}
    <p className={styles.body}>{children}</p>
  </aside>
);

export default Callout;
